import { cleanString } from '../../utils.js';

var subunit = (_ref => {
  let {
    subunit_name = '',
    subunit_type = ''
  } = _ref;
  return () => ({
    /**
     * subunit_name can include a number (like a package_id) along side string values such as
     * "shopping". Because the input type can be number or string but the Data Registry API will
     * only accept strings for this field, the value will always be coerced to a string.
     * @type {String|Number}
     */
    subunit_name: cleanString(subunit_name.toString()),
    subunit_type
  });
});

export default subunit;
